import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function MarketingNav() {
  return (
    <header className="sticky top-0 z-40 bg-[#FAF7F2]/85 backdrop-blur-xl border-b border-[#EFECE6]">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link"><Logo /></Link>
        <nav className="flex items-center gap-1 sm:gap-4 text-sm font-semibold">
          <a href="/#pricing" className="hidden sm:inline px-2 hover:text-[#D97706]" data-testid="nav-pricing-link">Pricing</a>
          <Link to="/blog" className="hidden sm:inline px-2 hover:text-[#D97706]" data-testid="nav-blog-link">Guides</Link>
          <Link to="/login" className="px-3 py-2 hover:text-[#D97706]" data-testid="nav-login-link">Log in</Link>
          <Link to="/signup" className="pl-btn-primary !min-h-[40px] !px-4 text-sm" data-testid="nav-start-trial-btn">Start free trial</Link>
        </nav>
      </div>
    </header>
  );
}

export function MarketingFooter() {
  return (
    <footer className="bg-[#1E293B] text-slate-300 mt-24">
      <div className="max-w-6xl mx-auto px-5 py-14 grid gap-10 sm:grid-cols-4">
        <div className="sm:col-span-2 space-y-3">
          <Logo light />
          <p className="text-sm max-w-sm">One shared log for every pet and everyone who cares for them. A tracking and reminder tool, never medical advice.</p>
        </div>
        <div className="space-y-2 text-sm">
          <p className="font-heading text-white font-semibold">Free resources</p>
          <Link to="/pet-sitter-checklist" className="block hover:text-white" data-testid="footer-checklist-link">Printable pet sitter checklist</Link>
          <Link to="/blog" className="block hover:text-white" data-testid="footer-blog-link">Pet care guides</Link>
        </div>
        <div className="space-y-2 text-sm">
          <p className="font-heading text-white font-semibold">PackLog</p>
          <a href="/#pricing" className="block hover:text-white">Pricing</a>
          <Link to="/privacy" className="block hover:text-white" data-testid="footer-privacy-link">Privacy policy</Link>
          <Link to="/terms" className="block hover:text-white" data-testid="footer-terms-link">Terms of service</Link>
        </div>
      </div>
      <p className="text-center text-xs text-slate-500 pb-8">© {new Date().getFullYear()} PackLog. We never sell or share your data.</p>
    </footer>
  );
}

export function MarketingPage({ children }) {
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <MarketingNav />
      {children}
      <MarketingFooter />
    </div>
  );
}
